<template>
  <div style="width:2.343vw;height:2.343vw;background:transparent;position:relative;">
    <canvas width="60" height="60" ref="slidableRingCanvas"></canvas>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    slideValue: {
      type: Number,
      required: false,
      default: 100,
    }
  },
  watch: {
    slideValue(newValue) { drawRing(newValue) }
  },
  data() {
    return {
    };
  },
  mounted(){
    this.drawRing(this.slideValue)
  },
  methods: {
    drawRing(value) {
      const canvas = this.$refs.slidableRingCanvas
      const ctx = canvas.getContext('2d')
      const radius = 20
      const centerX = canvas.width / 2
      const centerY = canvas.height / 2
      ctx.clearRect(0, 0, canvas.width, canvas.height) // 清空画布
      // 绘制圆环背景
      ctx.beginPath()
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2)
      ctx.strokeStyle = '#e0e0e0' // 背景颜色
      ctx.lineWidth = 6
      ctx.stroke()
      // 创建渐变色
      const gradient = ctx.createLinearGradient(centerX - radius, centerY - radius, centerX + radius, centerY + radius)
      gradient.addColorStop(0, 'rgba(126, 180, 235, 1)') // 渐变起始颜色
      gradient.addColorStop(1, 'rgba(177, 110, 249, 1)') // 渐变结束颜色
      // 绘制进度条
      const endAngle = (Math.PI * 2 * value) / 100 - Math.PI / 2 // 计算结束角度
      ctx.beginPath()
      ctx.arc(centerX, centerY, radius, -Math.PI / 2, endAngle)
      ctx.strokeStyle = gradient // 使用渐变色
      ctx.lineWidth = 6
      ctx.stroke()
    }
  }
};
</script>